import { render, staticRenderFns } from "./Singpass.vue?vue&type=template&id=c11bad32&"
import script from "./Singpass.vue?vue&type=script&lang=js&"
export * from "./Singpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports